import { IdentityProductGraphics, IdentityQrFrame, identityCssVariables, identityProductLanguage } from "./designSystem";
import { getStickerShape } from "./designSystem/stickerShapeDesign";

function PaddockSticker({ settings, headerLogo, qr, vehicleTitle, shape = "standard" }) {
  const geometry = getStickerShape(shape);
  const style = { ...identityCssVariables(settings.accentColor, settings.baseTheme), "--sticker-clip": geometry.clipPath };
  return (
    <div className={`identity-sticker-shell shape-${geometry.id}`} style={style}>
      <div className={`identity-sticker-artwork base-${settings.baseTheme} finish-${settings.finish}`}>
        <IdentityProductGraphics product="sticker" />
        <img className="paddock-logo-img" src={headerLogo} alt="MyBuildID" />
        {settings.showCarName && vehicleTitle && <p className="paddock-vehicle-name" title={vehicleTitle}>{vehicleTitle}</p>}
        <IdentityQrFrame variant={identityProductLanguage.sticker.qrFrame} className="paddock-qr-wrap">{qr}</IdentityQrFrame>
        <div className="paddock-copy"><strong>Scan to view my build</strong><span>MYBUILDID.COM</span></div>
      </div>
    </div>
  );
}

export default PaddockSticker;
